/* eslint-disable react/prop-types */
import React from "react";
import cx from "classnames";
import Popper from "@material-ui/core/Popper";
import Grow from "@material-ui/core/Grow";
import Paper from "@material-ui/core/Paper";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import MenuList from "@material-ui/core/MenuList";
import MenuItem from "@material-ui/core/MenuItem";

export default function InputDrawerDownloadPopper({
  classes,
  t,
  downloadButtonPopperOpen,
  downloadInProgress,
  onClickAwayDownloadFileSelection,
  onDownloadFileSelection,
  cleaned_up_file,
  processed_file_available = true,
}) {
  return (
    <Popper
      open={Boolean(downloadButtonPopperOpen) || downloadInProgress !== null}
      anchorEl={downloadButtonPopperOpen}
      transition
      disablePortal
      placement="bottom"
      className={cx({
        [classes.popperClose]: !downloadButtonPopperOpen,
        [classes.popperResponsive]: true,
      })}
    >
      {({ TransitionProps }) => (
        <Grow
          {...TransitionProps}
          id="download-file-menu-list"
          style={{ transformOrigin: "0 0 0" }}
        >
          <Paper className={classes.dropdown}>
            <ClickAwayListener onClickAway={onClickAwayDownloadFileSelection}>
              <MenuList
                role="menu"
                className={classes.inputDrawerDownloadMenuList}
              >
                <MenuItem
                  onClick={() => onDownloadFileSelection("original")}
                  className={cx({
                    [classes.dropdownItem]: true,
                    [classes.clientHover]: downloadInProgress === null,
                    [classes.downloadInProgress]:
                      downloadInProgress === "original",
                  })}
                >
                  {t("modeling_inputs_v2.download_original")}
                </MenuItem>
                {cleaned_up_file && processed_file_available === true && (
                  <MenuItem
                    onClick={() => onDownloadFileSelection("cleaned_up")}
                    className={cx({
                      [classes.dropdownItem]: true,
                      [classes.clientHover]: downloadInProgress === null,
                      [classes.downloadInProgress]:
                        downloadInProgress === "cleaned_up",
                    })}
                  >
                    {t("modeling_inputs_v2.download_cleaned_up")}
                  </MenuItem>
                )}
              </MenuList>
            </ClickAwayListener>
          </Paper>
        </Grow>
      )}
    </Popper>
  );
}
